<div class="padding">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }

  @if (dataAvailable()) {
    <app-table-template
      tableTitle="Related Parties"
      [showTitle]="false"
      [showSearch]="true"
      [showToggle]="true"
      [hasCardView]="true"
      [showPagination]="true"
      [clickableRows]="false"
      [columns]="columns()"
      [currentPage]="currentPage()"
      [sortedOn]="sortField()"
      [sortDescending]="sortOrder() === -1"
      [tableMinWidthInRem]="68"
      (sortChanged)="sort($event)"
      (searchChanged)="search($event)"
      (pageChanged)="page($event)">
      <app-related-party-card [currentPage]="currentPage()"></app-related-party-card>
    </app-table-template>
  }

  @if (dataEmpty()) {
    <div class="empty">No related parties available</div>
  }
</div>
